import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AsyncAjaxGet } from 'components/AsyncAjaxServiceV2';
import { utils } from 'vagaro-website-rendering/src/utils/Utils';


let BusinessData = [];
const VagaroAPIEnum = {
    businessMultilocation: "businesslogincustomerdetails/businesslocationasync"
};
export const BusinessLocation = createAsyncThunk(
    'GetBusinessLocation',
    async (Requestdata, thunkApi) => {
        let LoginDetails = utils.ReadCookie();
        let LoginUserId = LoginDetails === undefined || LoginDetails === "" || LoginDetails === null ? "" : LoginDetails.cEncUid === undefined || LoginDetails.cEncUid === null || LoginDetails.cEncUid === "" ? "" : LoginDetails.cEncUid;
        await AsyncAjaxGet(
            VagaroAPIEnum.businessMultilocation + "?" + (Requestdata.VGURL != "" ? ("SiteName=&VagaroURL=" + Requestdata.VGURL) + "&UserId=" + LoginUserId : ("SiteName=" + Requestdata.SiteName + "&VagaroURL=") + "&UserId=" + LoginUserId),
            Requestdata.access_token,
            function onSuccess(data) {
                if (data != null && data.data != null) {
                    BusinessData = data.data.data;
                    if (typeof BusinessData != "undefined" && BusinessData != null && BusinessData != "" && BusinessData.length > 0) {
                        localStorage.setItem('VgBUrl', Requestdata.VGURL);
                    }
                    $(".wbloader").css("display", "none");
                }
                else {
                    return thunkApi.rejectWithValue([]);
                }
            },
            function OnError() {
                return thunkApi.rejectWithValue([]);
            }
        );
        return thunkApi.fulfillWithValue(BusinessData);
    }
)

export const BusinessLocationSlice = createSlice({
    name: 'BusinessLocation',
    initialState: {
        data: [],
        isCompletedLocationCall: false
    },
    extraReducers: {
        [BusinessLocation.fulfilled]: (state, action) => {
            if (typeof action.payload !== undefined && action.payload !== null) {
                state.data = action.payload;
                state.isCompletedLocationCall = true;
            }
        }
    }
})
export default BusinessLocationSlice.reducer;
